export var TipEventNames;
(function (TipEventNames) {
    TipEventNames["didTip"] = "did_tip";
    TipEventNames["didFinishTipping"] = "did_finish_tipping";
    TipEventNames["didModuleLoaded"] = "did_module_loaded";
})(TipEventNames || (TipEventNames = {}));
